import Box from "@material-ui/core/Box";
import axios from "axios";
import MaterialTable from "material-table";
import QRCode from "qrcode.react";
import React from "react";
import { store as storeNotification } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import { loadShopData } from "../actions/shopLoadData";
import { IP } from "../config/IP";

export default function ShopAllocateProductStockForm(props) {
	const { useState, useEffect } = React;
	const state = useSelector((state) => state);

	const [columns, setColums] = useState([
		{
			title: "ProductCartCode",
			editable: "never",

			render: (rowData) => {
				console.log("QRCode rowData=", rowData);
				//let link = `${IP.reactServer}shop/addCart/${rowData.companyId}/${rowData.id}/${rowData.categoryId}/${rowData.subCategoryId}/${rowData.productId}/${rowData.stockId}`;
				let link = JSON.stringify({
					companyId: rowData.companyId,
					id: rowData.id,
					categoryId: rowData.categoryId,
					subCategoryId: rowData.subCategoryId,
					productId: rowData.productId,
					stockId: rowData.stockId,
				});
				console.log("add to cart link =", link);

				return <QRCode value={link} size={90} />;
			},
		},
		{
			title: "Site",
			field: "site",
			editable: "never",
			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},

		{
			title: "Allocation",
			field: "allocation",
			type: "numeric",
			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
		{
			title: "Ordered",
			field: "ordered",
			type: "numeric",
			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
		{
			title: "Address",
			field: "address",
			editable: "never",
			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
	]);

	const [data, setData] = useState([]);
	useEffect(() => {
		setData(
			state.companyData.allCompany
				.find((x) => x._id === state.companyData.selectedCompanyId)
				.site.map((x) => {
					let allocationValue = 0;
					let orderedValue = 0;
					try {
						console.log(
							`state.shopData.data.data
								.find((y) => y._id === props.data.categoryId)
								.subCategory.find((k) => k._id === props.data.subCategoryId)=`,
							state.shopData.data.data
								.find((y) => y._id === props.data.categoryId)
								.subCategory.find((k) => k._id === props.data.subCategoryId)
						);
						console.log("ShopAllocateProductStockForm x.siteId=", x.siteId);
						allocationValue = state.shopData.data.data
							.find((y) => y._id === props.data.categoryId)
							.subCategory.find((k) => k._id === props.data.subCategoryId)
							.productItems.find((z) => z._id === props.data.productId)
							.siteStockAllocation.filter(
								(i) => i.siteId === x._id && i.stockId === props.data.stockId
							)
							.reduce((a, b) => {
								return a + b.allocation;
							}, 0);

						orderedValue = state.shopData.data.data
							.find((y) => y._id === props.data.categoryId)
							.subCategory.find((k) => k._id === props.data.subCategoryId)
							.productItems.find((z) => z._id === props.data.productId)
							.siteStockAllocation.filter(
								(i) => i.siteId === x._id && i.stockId === props.data.stockId
							)
							.ordered.reduce((a, b) => {
								return a + b.allocation;
							}, 0);
					} catch (e) {
						console.log("error reduce allocation e=", e);
					}
					return {
						id: x._id,
						companyId: state.companyData.selectedCompanyId,
						categoryId: props.data.categoryId,
						subCategoryId: props.data.subCategoryId,
						productId: props.data.productId,
						stockId: props.data.stockId,

						site: x.name.trim(),
						address: x.address,
						allocation: allocationValue,
						ordered: orderedValue,
					};
				})
		);
	}, []);
	console.log("ShopAllocateProductStockForm props.data=", props.data);

	return (
		<Box width="50%">
			<MaterialTable
				title="Allocation to Sites"
				columns={columns}
				data={data}
				detailPanel={(rowData) => {
					return (
						<ShopAllocateProductStockForm_2
							data={{
								categoryId: rowData.categoryId,
								subCategoryId: rowData.subCategoryId,
								productId: rowData.productId,
								stockId: rowData.stockId,
								companyId: rowData.companyId,
								siteId: rowData.id,
							}}
						/>
					);
				}}
				editable={
					{
						/*onRowAdd: (newData) =>
						new Promise((resolve, reject) => {
							setTimeout(() => {
								setData([...data, newData]);

								resolve();
							}, 1000);
						}),
						*/
						/*onRowUpdate: (newData, oldData) =>
						new Promise((resolve, reject) => {
							setTimeout(() => {
								const dataUpdate = [...data];
								const index = oldData.tableData.id;

								console.log("ShopAllocateProductStockForm newData=", newData);

								const token = localStorage.getItem("token");
								const config = {
									headers: {
										"x-auth-token": token,
										"content-type": "application/json",
									},
								};

								axios
									.post(
										IP.nodeServer + "api/editShopCategoryDetails",
										{
											action: "update_stock_sites",
											categoryId: props.data.categoryId,
											subCategoryId: props.data.subCategoryId,
											productId: props.data.productId,
											companyId: state.companyData.selectedCompanyId,
											siteId: newData.id,
											allocation: newData.allocation,
										},
										config
									)
									.then((response) => {
										dataUpdate[index] = newData;

										setData([...dataUpdate]);
										storeNotification.addNotification({
											title: "Upading!",
											message: "success Updates Stock",
											type: "success",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});

										console.log("response.data=", response.data);
									})
									.catch((error) => {
										storeNotification.addNotification({
											title: "Updating!",
											message: "failed to update",
											type: "danger",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});
										return;
									});

								resolve();
							}, 1000);
						}),
					/*onRowDelete: (oldData) =>
					new Promise((resolve, reject) => {
						setTimeout(() => {
							const dataDelete = [...data];
							const index = oldData.tableData.id;
							dataDelete.splice(index, 1);
							setData([...dataDelete]);

							resolve();
						}, 1000);
					}),
					*/
					}
				}
			/>
		</Box>
	);
}
function ShopAllocateProductStockForm_2(props) {
	const { useState, useEffect } = React;
	const state = useSelector((state) => state);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	const [columns, setColums] = useState([
		{
			title: "allocation",
			field: "allocation",
			type: "numeric",

			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
		{
			title: "allocationDate",
			field: "allocationDate",
			editable: "never",

			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
		{
			title: "transationType",
			field: "transationType",
			editable: "never",

			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
		{
			title: "OrderId",
			field: "orderId",
			editable: "never",

			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
		{
			title: "User",
			field: "user",
			editable: "never",

			cellStyle: { padding: "5px", wordBreak: "break-all" },
		},
	]);

	const [data, setData] = useState([]);
	useEffect(() => {
		setData(
			state.shopData.data.data
				.find((y) => y._id === props.data.categoryId)
				.subCategory.find((k) => k._id === props.data.subCategoryId)
				.productItems.find((z) => z._id === props.data.productId)
				.siteStockAllocation.filter(
					(i) =>
						i.siteId === props.data.siteId && i.stockId === props.data.stockId
				)
				.map((x) => {
					return {
						companyId: x.companyId,
						siteId: x.siteId,
						stockId: x.stockId,
						allocation: x.allocation,
						allocationDate: x.allocationDate,
						transationType: x.transationType,
						orderId: x.orderId,
						user: state.auth.user.allUser.find((k) => k._id === x.userId).name,
						userId: x.userId,
					};
				})
		);
	}, []);

	React.useEffect(() => {
		try {
			if (loading) {
				let inputs = {
					url: IP.nodeServer + "api/loadShopData",
					method: "POST",
					data: [
						{ name: "companyId", value: state.auth.user.allCompanies[0]._id },
					],
				};
				console.log("loadShopData=", inputs);
				dispatch(loadShopData(inputs));
			}
		} catch (e) {}
	}, [loading, setLoading]);
	console.log("ShopAllocateProductStockForm_2 props.data=", props.data);

	return (
		<Box width="50%">
			<MaterialTable
				title="Details"
				columns={columns}
				data={data}
				editable={{
					onRowAdd: (newData) =>
						new Promise((resolve, reject) => {
							setTimeout(() => {
								console.log(
									"ShopAllocateProductStockForm_2 add  newData=",
									newData
								);

								const token = localStorage.getItem("token");
								const config = {
									headers: {
										"x-auth-token": token,
										"content-type": "application/json",
									},
								};
								let insert = {
									action: "update_stock_sites",
									companyId: props.data.companyId,
									categoryId: props.data.categoryId,
									subCategoryId: props.data.subCategoryId,
									productId: props.data.productId,
									siteId: props.data.siteId,
									stockId: props.data.stockId,
									allocation: newData.allocation,
								};
								console.log("ShopAllocateProductStockForm_2 insert=", insert);

								axios
									.post(
										IP.nodeServer + "api/editShopCategoryDetails",
										insert,
										config
									)
									.then((response) => {
										console.log(
											"ShopAllocateProductStockForm_2 response=",
											response
										);
										setLoading(true);

										storeNotification.addNotification({
											title: "adding",
											message: "success Updates Stock",
											type: "success",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});

										console.log("response.data=", response.data);
									})
									.catch((error) => {
										storeNotification.addNotification({
											title: "Updating!",
											message: "failed to update",
											type: "danger",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});
										return;
									});

								resolve();
							}, 1000);
						}),

					/* onRowUpdate: (newData, oldData) =>
						new Promise((resolve, reject) => {
							setTimeout(() => {
								const dataUpdate = [...data];
								const index = oldData.tableData.id;

								console.log("ShopAllocateProductStockForm newData=", newData);

								const token = localStorage.getItem("token");
								const config = {
									headers: {
										"x-auth-token": token,
										"content-type": "application/json",
									},
								};

								axios
									.post(
										IP.nodeServer + "api/editShopCategoryDetails",
										{
											action: "update_stock_sites",
											companyId: newData.companyId,
											siteId: newData.siteId,
											stockId: newData.stockId,
											allocation: newData.allocation,
										},
										config
									)
									.then((response) => {
										dataUpdate[index] = newData;

										setData([...dataUpdate]);
										storeNotification.addNotification({
											title: "Upading!",
											message: "success Updates Stock",
											type: "success",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});

										console.log("response.data=", response.data);
									})
									.catch((error) => {
										storeNotification.addNotification({
											title: "Updating!",
											message: "failed to update",
											type: "danger",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});
										return;
									});

								resolve();
							}, 1000);
						}),
						*/
					/*onRowDelete: (oldData) =>
					new Promise((resolve, reject) => {
						setTimeout(() => {
							const dataDelete = [...data];
							const index = oldData.tableData.id;
							dataDelete.splice(index, 1);
							setData([...dataDelete]);

							resolve();
						}, 1000);
					}),
					*/
				}}
			/>
		</Box>
	);
}
